import { useState } from "react";
import "./Style.scss";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SocialMedia from "../components/SocialMedia";
import Address from "../components/Address";
import JoinUs from "../components/JoinUs";
import Banner from "../components/Banner";

function Contact() {
    const [status, setStatus] = useState("idle");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("submitting");

        const form = e.target;

        try {
            const response = await fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams(new FormData(form)).toString(),
            });

            if (response.ok) {
                form.reset();
                setStatus("success");
            } else {
                setStatus("error");
            }
        } catch {
            setStatus("error");
        }
    };

    return (
        <div className="page">
            <Header active="contact" />

            <Banner></Banner>

            <div className="seperator"><div className="container"></div></div>

            <div className="section">
                <div className="container">
                    <h1 className="colorWhite text-start" style={{ marginBottom: "30px" }}>Contact Us</h1>

                    <div className="row text-start">
                        <div className="col-12 col-md-8">
                            {status === "success" && (
                                <div className="alert alert-success" role="alert">
                                    Thank you for reaching out. We&apos;ll get back to you soon.
                                </div>
                            )}
                            {status === "error" && (
                                <div className="alert alert-danger" role="alert">
                                    Something went wrong. Please try again or email us at contact@astungaming.com.
                                </div>
                            )}

                            <form
                                name="contact"
                                method="POST"
                                data-netlify="true"
                                data-netlify-honeypot="bot-field"
                                onSubmit={handleSubmit}
                            >
                                <input type="hidden" name="form-name" value="contact" />
                                <p className="d-none">
                                    <label>
                                        Don&apos;t fill this out: <input name="bot-field" />
                                    </label>
                                </p>

                                <div className="row">
                                    <div className="col-6 mb-3">
                                        <label className="form-label" htmlFor="firstName">First name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="firstName"
                                            name="firstName"
                                            required
                                        />
                                    </div>
                                    <div className="col-6 mb-3">
                                        <label className="form-label" htmlFor="lastName">Last name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="lastName"
                                            name="lastName"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label" htmlFor="email">Email address</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        name="email"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label" htmlFor="phone">Phone</label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="phone"
                                        name="phone"
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label" htmlFor="message">Message</label>
                                    <textarea
                                        className="form-control"
                                        id="message"
                                        name="message"
                                        style={{ minHeight: "130px" }}
                                        required
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    className="btn customButton filled blueTheme"
                                    style={{ marginTop: "30px", width: "150px", height: "50px" }}
                                    disabled={status === "submitting"}
                                >
                                    {status === "submitting" ? "Sending..." : "Submit"}
                                </button>
                            </form>
                        </div>

                        <div className="col-12 col-md-1"></div>

                        <div className="col-12 col-md-3">
                            <div className="mb-5">
                                <div className="pageHeading">
                                    <h2>&nbsp;</h2>
                                </div>
                                <Address heading="Our address" />
                            </div>

                            <div className="mb-5">
                                <h4 className="text-uppercase" style={{ color: "#AAA" }}>Email</h4>
                                <a href="mailto:contact@astungaming.com">contact@astungaming.com</a>
                            </div>

                            <div className="mb-5">
                                <h4 className="text-uppercase" style={{ color: "#AAA" }}>Phone</h4>
                                <a href="tel:+918588865196">+91-85888 65196</a>
                            </div>

                            <SocialMedia heading="Follow Us" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="seperator"><div className="container"></div></div>

            <JoinUs></JoinUs>

            <Footer />
        </div>
    );
}

export default Contact;
